import { useEffect } from "react";

import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { useJwtStorage, useLocalStorage, clearLocalStorage } from "../hooks/useLocalStorage";

import {
  getUserPriority,
} from "../services/UserService";
import { getSchoolByEid } from "../services/SchoolService";

const Intake = () => {
  const navigate = useNavigate();

  const { schoolEid, atJwt } = useParams();
  const [jwt, setJwt] = useJwtStorage();
  const [school, setSchool] = useLocalStorage("Auth", "school", null);
  const [, setUser] = useLocalStorage("Auth", "user", {});

  const [, setProductName] = useLocalStorage("Auth", "productName", "AllTimely");
  const [, setProductSource] = useLocalStorage("Auth", "productSource", "");
  
  const evalWelcome = (jwt) => {
    console.log(`Evaluating welcome for JWT: ${jwt}`);
    const priority = getUserPriority(jwt);

    if (priority === 500) {
      navigate("/student/welcome");
    } else {
      navigate("/teacher/welcome");
    }
  };


  useEffect(() => {
    clearLocalStorage();
    setJwt(atJwt);

    const school = getSchoolByEid(schoolEid);
    setSchool(school);
    setUser({
      "allowEditCalendar": "N"
    });

    setProductName(school.title);
    setProductSource("site");

    evalWelcome(atJwt);
  }, [school, atJwt, jwt, setJwt, evalWelcome]);

  return (
    <>
    </>
  );
};

export default Intake;
